import { Col, Row } from "antd";
import React from "react";

export default function BottomFooter() {
  return (
    <Row
      className="w-font-sm fw-600"
      style={{ color: "#878787", padding: 16 }}
      justify={"space-between"}
    >
      <Col>
        <p>WAX 2023©</p>
      </Col>
      <Col>
        <Row >
          <Col style={{marginRight: 16}}> 
            <a href="https://virl.com/privacy">Privacy Policy</a>
          </Col >
          <Col>
            <a href="https://virl.com/terms">Terms & Services</a>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
